import React, { useState } from 'react'
import "./Successfull_Modal.css";
import { Button, Modal } from "react-bootstrap";
import Successfull_Lottie from "../../../../animation/successfull_lottie/Successfull_Lottie";

function Successfull_Modal(props) {
  
  return (
    <>
      <div className="Successfull_Modal_sec">
        <Modal
          className="Successfull_Modal"
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>{props.headtext}</Modal.Header>
          <Modal.Body>

          <p className="top_text">{props.successfultext}</p>

            <div className="lottie_holder">            
              <Successfull_Lottie />
            </div>    

            <p className="bottom_text">{props.subtext}</p>  
            <p className="bottom_text">{props.subtext2}</p>  

          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default Successfull_Modal;
